/* tslint:disable */
/* eslint-disable */
/**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * A delegation.
 * @export
 * @interface Delegation
 */
export interface Delegation {
    /**
     * The amount of tokens delegated in base units.
     * @type {string}
     * @memberof Delegation
     */
    amount: string;
    /**
     * The shares of tokens delegated.
     * @type {string}
     * @memberof Delegation
     */
    shares: string;
    /**
     * The delegatee (validator) address.
     * @type {string}
     * @memberof Delegation
     */
    validator: string;
    /**
     * The delegator address.
     * @type {string}
     * @memberof Delegation
     */
    delegator: string;
}

export function DelegationFromJSON(json: any): Delegation {
    return DelegationFromJSONTyped(json, false);
}

export function DelegationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Delegation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'amount': json['amount'],
        'shares': json['shares'],
        'validator': json['validator'],
        'delegator': json['delegator'],
    };
}

export function DelegationToJSON(value?: Delegation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'amount': value.amount,
        'shares': value.shares,
        'validator': value.validator,
        'delegator': value.delegator,
    };
}


